<table class="results-table" [ngStyle]="getStyle()" [class.is-hi-contrast]="isHiContrast()" data-ui-name="Results summary sr table" data-ui-component="results-summary-sr" data-testid="results-summary-sr-results-summary-sr-table">
    <tr data-ui-name="Tr results sr questions headings row" data-ui-component="results-summary-sr" data-testid="results-summary-sr-tr-results-sr-questions-headings-row">
        <th colspan="3"><tra slug="tr_results_sr_questions"></tra></th>
    </tr>
    <tr *ngIf="showScore" data-ui-name="Tr results score values row" data-ui-component="results-summary-sr" data-testid="results-summary-sr-tr-results-score-values-row">
        <td>
            <tra slug="tr_results_score"></tra>
        </td>
        <td>
            {{getCorrectSRScore()}}/{{totalSRScore}}
        </td>
        <td>
            ({{getSRPercentage()}}%)
        </td>
    </tr>
    <tr *ngIf="showScore" data-ui-name="Results summary sr row" data-ui-component="results-summary-sr" data-testid="results-summary-sr-results-summary-sr-row"><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>
    <tr data-ui-name="Tr results total questions values row" data-ui-component="results-summary-sr" data-testid="results-summary-sr-tr-results-total-questions-values-row">
        <td>
            <tra slug="tr_results_total_questions"></tra>
        </td>
        <td>
            {{numSRQuestions}}
        </td>
        <td>
        </td>
    </tr>
    <tr data-ui-name="Tr results correct ans values row" data-ui-component="results-summary-sr" data-testid="results-summary-sr-tr-results-correct-ans-values-row">
        <td>
            <tra slug="tr_results_correct_ans"></tra>
        </td>
        <td>
            {{numCorrectSRQuestions}}
        </td>
        <td>
        </td>
    </tr>
    <tr data-ui-name="Tr results incorrect ans values row" data-ui-component="results-summary-sr" data-testid="results-summary-sr-tr-results-incorrect-ans-values-row">
        <td>
            <tra slug="tr_results_incorrect_ans"></tra>
        </td>
        <td>
            {{getNumIncorrectSRQuestions()}}
        </td>
        <td>
        </td>
    </tr>
</table>
<div *ngIf="isCustomResultPageNote" style="margin-top: 0.1em; margin-bottom:1em; font-style: italic; font-size: 0.8em;">
    <!-- <tra style="font-style: italic;" slug="note_title"></tra> -->
    <span *ngIf="lang.c() === 'en'" [innerHTML]="customResultPageNoteEN"></span>
    <span *ngIf="lang.c() === 'fr'" [innerHTML]="customResultPageNoteFR"></span>
</div>